"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentsCountFieldLogic = void 0;
var comments_count_fieldtype_1 = require("./comments.count.fieldtype");
Object.defineProperty(exports, "CommentsCountFieldLogic", { enumerable: true, get: function () { return comments_count_fieldtype_1.CommentsCountFieldLogic; } });
